<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default { name: "App" }
</script>

<style>
.v-application {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  background: #f5f5f0 !important;
}
.v-application--wrap {
  background: #f5f5f0;
}
</style>
